import React from "react";
import { Button, Modal } from "antd";
import { EditOutlined } from "@ant-design/icons";
import logo from "../../../../images/logo.png";
import "../../css/record-detail-modal.css";

export interface RecordDetailFieldI {
  label: string;
  value?: React.ReactNode;
  full?: boolean;
}

export interface RecordDetailSectionI {
  title: string;
  fields: RecordDetailFieldI[];
}

export interface RecordDetailTagI {
  label: string;
  muted?: boolean;
}

interface RecordDetailModalPropsI {
  open: boolean;
  onClose: () => void;
  eyebrow: string;
  title?: string | null;
  subtitle?: string | null;
  image?: string | null;
  tags?: RecordDetailTagI[];
  sections: RecordDetailSectionI[];
  onEdit?: () => void;
}

const isEmpty = (value: React.ReactNode) =>
  value === undefined || value === null || value === "";

export const RecordDetailModal = ({
  open,
  onClose,
  eyebrow,
  title,
  subtitle,
  image,
  tags = [],
  sections,
  onEdit,
}: RecordDetailModalPropsI) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width={640}
    centered
    destroyOnClose
    className="rdm"
  >
    <div className="rdm-header">
      <div className={`rdm-avatar${image ? " rdm-avatar-photo" : ""}`}>
        <img src={image || logo} alt={title || "MALIMAX"} />
      </div>
      <div className="rdm-heading">
        <p className="rdm-eyebrow">{eyebrow}</p>
        <h3 className="rdm-title">{title || "—"}</h3>
        {subtitle ? <p className="rdm-subtitle">{subtitle}</p> : null}
        {tags.length > 0 ? (
          <div className="rdm-tags">
            {tags.map((tag) => (
              <span
                key={tag.label}
                className={`rdm-tag${tag.muted ? " rdm-tag-muted" : ""}`}
              >
                {tag.label}
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </div>

    <div className="rdm-body">
      {sections.map((section) => (
        <section className="rdm-section" key={section.title}>
          <h4 className="rdm-section-title">{section.title}</h4>
          <div className="rdm-grid">
            {section.fields.map((field) => (
              <div
                key={field.label}
                className={`rdm-field${field.full ? " rdm-field-full" : ""}`}
              >
                <span className="rdm-label">{field.label}</span>
                <span
                  className={`rdm-value${isEmpty(field.value) ? " rdm-empty" : ""}`}
                >
                  {isEmpty(field.value) ? "—" : field.value}
                </span>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>

    <div className="rdm-footer">
      {onEdit ? (
        <Button icon={<EditOutlined />} onClick={onEdit}>
          Editar
        </Button>
      ) : null}
      <Button
        type="primary"
        onClick={onClose}
        style={{ background: "#0B0D0B", borderColor: "#0B0D0B" }}
      >
        Cerrar
      </Button>
    </div>
  </Modal>
);
